import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh
      gcTime: 10 * 60 * 1000, // 10 minutes - keep in memory longer
      refetchOnWindowFocus: false,
      retry: false, // Don't retry by default - hobby apps should fail fast
      refetchOnMount: false, // Don't auto-refetch when components mount
      refetchInterval: false // Disable automatic background refetching
    }
  }
})

export { queryClient }
